import axios from 'axios';

// En desarrollo el proxy de setupProxy.js evita el CORS (baseURL vacío = relativo)
// En producción el admin debe habilitar CORS en Frappe System Settings
const BASE_URL = process.env.NODE_ENV === 'development'
  ? ''
  : 'https://volteonelectronics.v.frappe.cloud';

const frappe = axios.create({
  baseURL: BASE_URL,
  headers: {
    Authorization: 'token 597c27dbf169d92:cedb208d540ca82',
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
});

export const WAREHOUSE_PRINCIPAL = 'Principal - VE';
export const WAREHOUSE_ANDRES = 'Andrés - VE';
export const COMPANY = 'Volteon Electronics';

// Mapeo de métodos de pago: códigos numéricos usados en el frontend → nombres en Frappe
const PAYMENT_MODES = {
  4: 'Cash',
  6: 'Credit Card',
  104: 'SINPE Móvil',
  106: 'SINPE',
};

export function mapPaymentMode(modeId) {
  return PAYMENT_MODES[parseInt(modeId, 10)] || 'Cash';
}

export default frappe;
